import React, { useState, useEffect } from 'react';
import { Input, Modal, message } from 'antd';
import './style.scss';

const OTPVplus = ({
  visible,
  length = 6,
  phoneNumber,
  onVerify = () => {},
  onResend = () => {},
  onCancel = () => {},
  timeLeft = 60,
  isResend = true,
  isOtpError = false,
  setIsOtpError = () => {},
  promotionTypeCode = "",
  specialPrivileges = 0,
  isCheckOffNet = false,
  ...props
}) => {
  const [otp, setOtp] = useState(Array(length).fill(null));
  const [timer, setTimer] = useState(timeLeft);
  const offNet = localStorage.getItem("off_net");

  useEffect(() => {
    if (visible) {
      setOtp(Array(length).fill(null));
    }
    if (!visible && isResend) {
      setTimer(timeLeft);
    }
  }, [visible]);

  useEffect(() => {
    let interval;
    if (timer > 0 && visible && isResend) {
      interval = setInterval(() => {
        setTimer((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer, visible]);

  const handleVerify = (otp) => {
    if (otp.every((digit) => digit !== '' && digit)) {
      onVerify(otp.join(''));
    } else {
      message.error('Please enter the complete OTP');
    }
  };
  const handleChange = (value, index) => {
    setIsOtpError(false);
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value !== '' && index < length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
    if (
      index === length - 1
      && newOtp?.every((digit) => digit !== '' && digit)
    ) {
      handleVerify(newOtp);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  const syncSelection = (e) => {
    e.target.select();
  };

  const handleResend = () => {
    setTimer(timeLeft);
    setOtp(Array(length).fill(null));
    setIsOtpError(false);
    onResend();
  };

  return (
    <Modal
      width={576}
      visible={visible}
      onCancel={onCancel}
      maskClosable={false}
      footer={null}
      centered
      title="Nhập mã OTP"
      className="modal-vplus"
    >
      <div className="otp-vplus">
        <div className="otp-title">
        {(offNet == 1 && (promotionTypeCode == 'QUATANG' || specialPrivileges == 1 || isCheckOffNet)) ? (
          <>
          Số điện thoại <span>088.8001091</span> sẽ gọi đến <span>{phoneNumber}</span> để cung cấp mã OTP.<br/>Quý khách vui lòng nghe máy
          </>
        ) : (
          <>
          Nhập mã xác thực OTP được gửi đến số điện thoại <span>{phoneNumber}</span>
          </>
        )}
        </div>
        <div className="otp-input">
          {otp.map((digit, index) => (
            <Input
              key={index}
              id={`otp-input-${index}`}
              className={isOtpError ? 'ringOTP' : ''}
              value={digit}
              onInput={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, '');
                handleChange(value, index)
              }}
              onKeyDown={(e) => handleKeyDown(e, index)}
              maxLength={1}
              onFocus={syncSelection}
              {...props}
            />
          ))}
        </div>

        {isResend && (
          <div className="otp-resend">
            <span
              className={`otp-resend-txt ${timer === 0 && 'active'}`}
              onClick={handleResend}
            >
              Gửi lại OTP{' '}
            </span>
            {timer > 0 && <span id="timer">({timer}s)</span>}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default OTPVplus;
